import { render, staticRenderFns } from "./reserveConfirmList.vue?vue&type=template&id=0fa518bb&scoped=true"
import script from "./reserveConfirmList.vue?vue&type=script&lang=js"
export * from "./reserveConfirmList.vue?vue&type=script&lang=js"
import style0 from "./reserveConfirmList.vue?vue&type=style&index=0&id=0fa518bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa518bb",
  null
  
)

export default component.exports